//--------------Web-Scraped-Products--------------
export const heightArray = [
    { value: "Average", label: "Average" },
    { value: "Tall", label: "Tall" },
    { value: "Petite", label: "Petite" },
];

export const paletteOptions = [
    { value: "Bright Spring", label: "Bright Spring" },
    { value: "Bright Winter", label: "Bright Winter" },
    { value: "Dark Autumn", label: "Dark Autumn" },
    { value: "Dark Winter", label: "Dark Winter" },
    { value: "Light Spring", label: "Light Spring" },
    { value: "Light Summer", label: "Light Summer" },
    { value: "Soft Autumn", label: "Soft Autumn" },
    { value: "Soft Summer", label: "Soft Summer" },
    { value: "True Autumn", label: "True Autumn" },
    { value: "True Spring", label: "True Spring" },
    { value: "True Summer", label: "True Summer" },
    { value: "True Winter", label: "True Winter" },
];

export const bodyShapeArray = [
    { value: "Round", label: "Round" },
    { value: "Triangle", label: "Triangle" },
    { value: "Hourglass", label: "Hourglass" },
    { value: "Rectangle", label: "Rectangle" },
    { value: "Inverted Triangle", label: "Inverted Triangle" },
];

export const styleIdentityArray = [
    { value: "Bold Boss", label: "Bold Boss" },
    { value: "Dreamy Diva", label: "Dreamy Diva" },
    { value: "Timeless Queen", label: "Timeless Queen" },
    { value: "Effortless Chic", label: "Effortless Chic" },
];

export const downplayArray = [
    { value: "Neckline", label: "Neckline" },
    { value: "Waist", label: "Waist" },
    { value: "Legs", label: "Legs" },
    { value: "Arms", label: "Arms" },
    { value: "Back", label: "Back" },
    { value: "Buttocks", label: "Buttocks" },
];
export const occasionArray = [
    { value: "Casual", label: "Casual" },
    { value: "Formal", label: "Formal" },
    { value: "Party", label: "Party" },
];

//--------------Web-Scraped-Products-End-------------